module.exports = __webpack_public_path__ + "static/img/qr_code.20faf01.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/qr_code.png
// module id = fqGg
// module chunks = 23